import React, { useEffect } from "react";
import Billingdetailsform from "../../components/Reuseablecomponents/Forms/Billingdetailsform/Billingdetailsform";
import Companydetailsform from "../../components/Reuseablecomponents/Forms/Companydetailsform/Companydetailsform";
import Referencesdetailsform from "../../components/Reuseablecomponents/Forms/Referencesdetailsform/Referencesdetailsform";
import "./Createaccountpage.css";

export default function Createaccountpage() {

    useEffect(() => {

        window.scrollTo(0, 0)

    }, [])

    return (
        <>

            {/* Create an account page start */}

            <div className="createaccountpage_container">
                <div className="row m-0">
                    <div className="col-md-3 createaccountpage_sidenav">

                        <h3 className="createaccountpage_sidenav_header">
                            Account Registration
                        </h3>

                        <p className="createaccountpage_sidenav_text">
                            Home/ Account
                        </p>

                        <ul className="nav nav-tabs flex-column" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active" id="company-tab" data-bs-toggle="tab" data-bs-target="#company" type="button" role="tab" aria-controls="company" aria-selected="true">
                                    Company
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link " id="billing-tab" data-bs-toggle="tab" data-bs-target="#billing" type="button" role="tab" aria-controls="billing" aria-selected="false">
                                    Billing
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link " id="references-tab" data-bs-toggle="tab" data-bs-target="#references" type="button" role="tab" aria-controls="references" aria-selected="false">
                                    References
                                </button>
                            </li>

                        </ul>
                    </div>
                    <div className="col-md-9 p-0">
                        <div className="createaccountpage_content">
                            <div className="tab-content" id="myTabContent">

                                <div className="tab-pane fade active show" id="company" role="tabpanel" aria-labelledby="company-tab">
                                    <Companydetailsform />
                                </div>
                                <div className="tab-pane fade billing_informaion " id="billing" role="tabpanel" aria-labelledby="billing-tab">
                                    <Billingdetailsform />
                                </div>
                                <div className="tab-pane fade " id="references" role="tabpanel" aria-labelledby="references-tab">
                                    <Referencesdetailsform />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Create an account page over */}

        </>
    )

}